/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popTipEnergy.vue?vue&type=template&id=4f980d3a&scoped=true"
import script from "./popTipEnergy.vue?vue&type=script&lang=js"
export * from "./popTipEnergy.vue?vue&type=script&lang=js"
import style0 from "./popTipEnergy.vue?vue&type=style&index=0&id=4f980d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f980d3a",
  null
  
)

export default component.exports